<template>
  <div>
    <div class="forgot-password">
      <div class="header">
        <img src="../assets/logo_black.svg" />
      </div>

      <div class="flex">
        <div class="panel" v-show="view === 'enter_email'">
          <h4>Forgot your password?</h4>
          <p>
            Enter your email address below, and we'll send you a code to reset
            your password
          </p>
          <form @submit.prevent="requestPasswordReset()">
            <material-input
              v-model="username"
              type="email"
              label="Email"
              :required="true"
              name="Email"
            />
            <button class="button" type="submit">Send</button>
            <router-link class="link" to="/login">Back to log in</router-link>
          </form>
        </div>

        <div class="panel" v-show="view === 'enter_password'">
          <h4>Check your email</h4>
          <p>
            We've emailed you a code, which you can enter below to reset your
            password
          </p>
          <form @submit.prevent="resetPassword()" autocomplete="off">
            <material-input
              v-model="code"
              type="text"
              label="Reset code"
              :required="true"
              name="Code"
              bgColor="white"
              :enableAutocomplete="false"
            />
            <material-input
              v-model="password"
              type="password"
              label="New password"
              :required="true"
              name="Password"
              bgColor="white"
              autocomplete="new-password"
            />
            <password-checks
              :password="password"
              :onChange="setNewPasswordValidity"
              class="checks"
            />
            <button
              class="button"
              type="submit"
              :disabled="!new_password_valid"
            >
              Reset
            </button>
          </form>
        </div>

        <div class="panel" v-show="view === 'confirm'">
          <img src="~@/assets/icons/checkmark.svg" />
          <h4>You have successfully changed your password</h4>
          <router-link class="button" to="/login">Back to log in</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MaterialInput from '../components/MaterialInput.vue';
import PasswordChecks from '../components/PasswordChecks';

export default {
  name: 'ForgotPassword',
  data() {
    return {
      username: '',
      code: '',
      password: '',
      new_password_valid: false,
      view: 'enter_email',
    };
  },
  components: {
    'material-input': MaterialInput,
    'password-checks': PasswordChecks,
  },
  methods: {
    setNewPasswordValidity(valid) {
      this.new_password_valid = valid;
    },
    async requestPasswordReset() {
      try {
        await this.$store.dispatch('requestPasswordReset', this.username);
        this.view = 'enter_password';
      } catch (err) {
        console.error(err.message || JSON.stringify(err));
      }
    },
    async resetPassword() {
      try {
        await this.$store.dispatch('resetPassword', {
          code: this.code,
          password: this.password,
        });
        this.view = 'confirm';
      } catch (err) {
        console.error(err.message || JSON.stringify(err));
      }
    },
  },
  created() {
    this.$ga.page('/forgotpassword/');
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

form {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.link {
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  color: #acb6c1 !important;
  text-align: center;
  margin-top: 20px;
}

.checks {
  margin-bottom: 30px;
}

.forgot-password {
  margin: -40px;
  width: calc(100% + 80px);
  height: calc(100% + 80px);

  .header {
    width: 100%;
    height: 80px;
    background: white;

    img {
      height: 40px;
      width: auto;
      margin-top: 20px;
      margin-left: 20px;
    }
  }

  .flex {
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100% - 80px);

    .panel {
      width: 100%;
      max-width: 600px;
      min-height: 200px;
      border-radius: 4px;
      background: white;
      padding: 60px;

      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      img {
        width: 100px;
        margin-bottom: 30px;
      }

      h4 {
        text-align: center;
        color: $sidebar-color;
        font-size: 24px;
        margin-bottom: 30px;
        max-width: 360px;
      }

      p {
        text-align: center;
        font-size: 14px;
        margin-top: -20px;
        margin-bottom: 40px;
        color: $sidebar-color;
        opacity: 0.6;
      }

      .button {
        width: 220px;
        margin: 0 auto;
      }
    }
  }
}
</style>
